// extracted by mini-css-extract-plugin
module.exports = {"slide":"e2ff468f85--slide--qk4si"};